import { render, staticRenderFns } from "./UserCredentials.vue?vue&type=template&id=6c915e5d&"
import script from "./UserCredentials.vue?vue&type=script&lang=js&"
export * from "./UserCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports